export const CrossIcon = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.09325 10L5.00322 5.90617L0.913183 10L0 9.0874L4.09646 5L0 0.912596L0.913183 0L5.00322 4.09383L9.09325 0.00642688L10 0.912596L5.90997 5L10 9.0874L9.09325 10Z"
        fill="#FFFDFD"
      />
    </svg>
  );
};
